
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/countries/${this.$route.query.id}`).then(res => {
        this.form = res.data
      })
    },
    save() {
      this.$http
        .put(`countries/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.$http.delete(`/countries/${this.$route.query.id}`).then(() => {
            this.$router.go(-1)
            this.$message('', '削除成功')
          })
        }
      )
    }
  }
}
</script>
